import {
  faListDropdown,
  faImages,
  faPaperclip,
  faSquareCheck,
  faMoneyCheck,
  faMoneyCheckPen,
  faSignature,
  faGears,
  faWarehouse,
  faReceipt,
  faFileSignature,
  faBallotCheck
} from '@fortawesome/pro-regular-svg-icons'

export const elementKeys = {
  TYPE: 'type',
  TITLE: 'title',
  WORK_TYPE: 'default',
  HELPFUL_HINT: 'helpful_hint',
  REQUIRED: 'required',
  EMPTY_STATE_MESSAGE: 'empty_state_message',
  INPUT_FIELD_TYPE: 'input_field_type',
  INPUT_TEXT_LENGTH: 'input_text_length',
  ATTRIBUTES: 'attributes',
  NESTED_LOGIC: 'nested_logic',
  LOGICAL_ACTION: 'logical_action',
  THEN_PERFORM: 'then_perform',
  SELECTION_TYPE: 'selection_type',
  OPTIONS: 'options',
  TIME_STAMP: 'time_stamp',
  DEPENDENCY: 'dependency',
  SELECTION_OPTION: 'selection_option',
  NUMBER_OF_PHOTOS: 'number_of_photos',
  NUMBER_OF_ATTACHMENTS: 'number_of_attachments',
  PHOTOS: 'photos',
  ATTACHMENTS: 'attachments',
  NUMBER_OF_BUTTONS: 'number_of_buttons',
  NUMBER_OF_SELECTIONS: 'number_of_selections',
  BUTTONS: 'buttons',
  SIGNATURE_ATTRIBUTES: 'signature_attributes',
  ITEM_PRICE: 'item_price',
  LABOR_TYPE: 'labor_type',
  RATE: 'rate',
  DESCRIPTION: 'description',
  TAX: 'tax',
  TOTAL_AMOUNT_DUE: 'total_amount_due',
  AUTHORIZATION_TO_PROCEED: 'authorization_to_proceed',
  PAYMENT_TERMS: 'payment_terms',
  PRODUCT_CREATION: 'product_creation',
  PRODUCT_NAME: 'product_name',
  PRODUCT_TYPE: 'product_type',
  PRODUCT_DESCRIPTION: 'product_description',
  PRICE_EACH: 'price_each',
  TOTAL_EACH: 'total_each'
}

export const elementTypes = {
  TEXT_DESCRIPTION: 'text_description',
  DROPDOWN_SELECTION: 'dropdown_selection',
  CHECKLIST_ITEM: 'checklist_item',
  PHOTOS: 'photos',
  ATTACHMENTS: 'attachments',
  MULTI_BUTTON_SELECTION: 'multi_button_selection',
  SIGNATURE: 'signature',
  MATERIAL_PARTS: 'material_parts',
  EQUIPMENT_INVENTORY: 'equipment_inventory',
  LINE_ITEMS: 'products_services',
  AUTHORIZATION_FIELD: 'authorization_field',
  PRODUCTS_SERVICES: 'products_services',
  SERVICE_CHECKLIST: 'service_checklist'
}

export const auditOptions = {
  PUBLISHED: 'active',
  DELETED: 'deleted',
  DRAFT: 'draft',
  CLONED: 'cloned',
  SAVED: 'saved',
  DEACTIVATED: 'deactivated'
}

export const auditType = 'screen_configs'

export const elementIcons = {
  [elementTypes.CHECKLIST_ITEM]: faSquareCheck,
  [elementTypes.DROPDOWN_SELECTION]: faListDropdown,
  [elementTypes.MULTI_BUTTON_SELECTION]: faMoneyCheck,
  [elementTypes.PHOTOS]: faImages,
  [elementTypes.ATTACHMENTS]: faPaperclip,
  [elementTypes.TEXT_DESCRIPTION]: faMoneyCheckPen,
  [elementTypes.SIGNATURE]: faSignature,
  [elementTypes.EQUIPMENT_INVENTORY]: faWarehouse,
  [elementTypes.MATERIAL_PARTS]: faGears,
  [elementTypes.LINE_ITEMS]: faReceipt,
  [elementTypes.SERVICE_CHECKLIST]: faBallotCheck,
  [elementTypes.PRODUCTS_SERVICES]: faGears,
  [elementTypes.AUTHORIZATION_FIELD]: faFileSignature
}

export const photoObjectTemplate = {
  title: '',
  location: true,
  time_stamp: true,
  required: false,
  attributes: 'take_photo_or_upload_from_gallery'
}

export const attachmentsObjectTemplate = {
  title: '',
  location: true,
  time_stamp: true,
  required: false,
  attributes: 'all_document_formats'
}

export const inputFieldTypeOptions = [
  'alpha_numeric_special_characters',
  'alpha_numeric',
  'alpha_only',
  'numeric_only',
  'dollar_value',
  'percentage_value',
  'date_time'
]

export const selectionOptionOptions = [
  'check_box',
  'toggle',
  'yes_no',
  'on_off'
]

export const paymentTermsOptions = [
  'due_on_receipt',
  'net_7',
  'net_15',
  'net_30',
  'net_45',
  'disable'
]

export const requiredAuthorizationOptions = [
  'signature_required',
  'signature_and_name_required',
  'disable'
]

export const requiredAuthorizationOptionsObj = {
  SIGNATURE_REQUIRED: 'signature_required',
  SIGNATURE_AND_NAME_REQUIRED: 'signature_and_name_required',
  DISABLE: 'disable'
}

export const itemPriceOptions = [
  'enable_item_price_tax_total_price',
  'disable_item_price_tax_total_price'
]

export const itemPriceOptionsObj = {
  ENABLE_ITEM_PRICE_TAX_TOTAL_PRICE: 'enable_item_price_tax_total_price',
  DISABLE_ITEM_PRICE_TAX_TOTAL_PRICE: 'disable_item_price_tax_total_price'
}

export const rateOptions = [
  'enable_selections_based_on_salesforce',
  'enable_custom_options',
  'disable'
]

export const rateOptionsObj = {
  ENABLE_SELECTIONS_BASED_ON_SALESFORCE:
    'enable_selections_based_on_salesforce',
  ENABLE_CUSTOM_OPTIONS: 'enable_custom_options',
  DISABLE: 'disable'
}

const laborTypeHarcodedOptions = ['Labor', 'Travel', 'Break', 'Bonus']

export const attributesOptions = [
  'take_photo_or_upload_from_gallery',
  'take_photo_only',
  'upload_photo_from_gallery_only'
]

export const attachmentsAttributesOptions = [
  'all_document_formats',
  'jpeg_and_png_only',
  'pdf_only',
  'csv_spreadsheet_only',
  'docx_only'
]

export const photosItemKeys = {
  TITLE: 'title',
  LOCATION: 'location',
  TIME_STAMP: 'time_stamp',
  REQUIRED: 'required',
  ATTRIBUTES: 'attributes'
}

export const attachmentsItemKeys = {
  TITLE: 'title',
  LOCATION: 'location',
  TIME_STAMP: 'time_stamp',
  REQUIRED: 'required',
  ATTRIBUTES: 'attributes'
}

export const selectionTypeOptions = ['single_selection', 'multiple_selections']
export const thenPerformOptions = Object.values(elementTypes)
export const signatureAttributesOptions = [
  'entered_name_required',
  'entered_name_optional'
]

export const lineItemsLogicalActionOptions = [
  'if_one_line_item_is_populated',
  'if_more_than_one_line_item_is_populated'
]

export const materialsLogicalActionOptions = [
  'if_one_material_is_populated',
  'if_more_than_one_material_is_populated'
]

export const maximumNumberOfPhotos = 16
export const maximumNumberOfButtons = 16
export const maximumNumberOfAttachments = 5

export const lineItemsFieldsOptions = ['hidden', 'view_only', 'editable']

// template elements used in the form builder
// add default values here
export const elements = [
  {
    type: elementTypes.TEXT_DESCRIPTION,
    title: '',
    helpful_hint: '',
    required: true, // default value true
    empty_state_message: '',
    input_field_type: 'alpha_numeric_special_characters', // default value alpha numeric
    input_text_length: 25,
    nested_logic: false,
    logical_action: 'if_text_is_populated', // by default if text id populated (only option for now)
    then_perform: ''
  },
  {
    type: elementTypes.DROPDOWN_SELECTION,
    title: '',
    helpful_hint: '',
    required: true, // default value true
    selection_type: 'single_selection', // default value single selection
    options: [''],
    nested_logic: false,
    logical_action: 1, // option to be selected bu default 1
    then_perform: ''
  },
  {
    type: elementTypes.CHECKLIST_ITEM,
    title: '',
    helpful_hint: '',
    time_stamp: false,
    required: true, // default value true
    selection_option: 'check_box',
    nested_logic: false,
    logical_action: true, // here we manage true/false options
    then_perform: ''
  },
  {
    type: elementTypes.PHOTOS,
    title: '',
    helpful_hint: '',
    required: false, // default value true, changes if at least we have one mandatory photo
    number_of_photos: 1,
    photos: [photoObjectTemplate]
  },
  {
    type: elementTypes.ATTACHMENTS,
    title: '',
    helpful_hint: '',
    required: false, // default value true, changes if at least we have one mandatory attachment
    number_of_attachments: 1,
    attachments: [attachmentsObjectTemplate]
  },
  {
    type: elementTypes.MULTI_BUTTON_SELECTION,
    title: '',
    helpful_hint: '',
    time_stamp: false,
    required: true,
    number_of_buttons: 1,
    number_of_selections: 'multiple_selections',
    buttons: [''],
    nested_logic: false,
    logical_action: 1, // option to be selected bu default 1
    then_perform: ''
  },
  {
    type: elementTypes.SIGNATURE,
    title: '',
    helpful_hint: '',
    time_stamp: false,
    required: true,
    attributes: 'entered_name_required', // required by default
    nested_logic: false,
    logical_action: 'if_signed', // signed by default
    then_perform: ''
  },
  {
    title: '',
    type: elementTypes.AUTHORIZATION_FIELD,
    helpful_hint: '',
    payment_terms: 'net_30',
    authorization_to_proceed: true,
    required: 'signature_required'
  }
]

export const customElements = [
  {
    type: elementTypes.LINE_ITEMS,
    title: '', // will be set up on object creation
    items_limit: 10,
    helpful_hint: '',
    required: false,
    product_creation: false,
    product_description: 'view_only',
    price_each: 'hidden',
    tax: 'hidden',
    total_each: 'hidden',
    nested_logic: false,
    logical_action: lineItemsLogicalActionOptions[0],
    labor_type_options: laborTypeHarcodedOptions
  },
  {
    type: elementTypes.SERVICE_CHECKLIST,
    title: '',
    helpful_hint: '',
    required: true
  }
]

export const getFirstKeyFromObject = obj => {
  if (!obj) return ''
  const objKeys = Object.keys(obj)
  if (objKeys?.length > 0) return Object.keys(obj)[0]
  else return ''
}

export const checkIfObjectExists = (array, key, value) => {
  return array.some(obj => obj[key] === value)
}

/**
 * Find returns a clone of the input json object
 * @param {object} object
 */
export const cloneDeep = object => {
  return JSON.parse(JSON.stringify(object))
}

export const formatSections = sections => {
  return sections.map((section, index) => {
    const sectionId = Object.keys(section)[0]
    const sectionTitle = section[sectionId].title
    const sectionData = section[sectionId].questions
    return {
      index,
      id: sectionId,
      title: sectionTitle,
      data: sectionData
    }
  })
}

export const checkNotFullfilled = (questionObj, field) => {
  // check if field is fullfilled
  let notFullfilled = true
  // if we have options we have to check
  // if we have missing options
  switch (field) {
    case elementKeys.BUTTONS:
    case elementKeys.OPTIONS: {
      if (questionObj.type !== elementTypes.LINE_ITEMS) {
        let missingOptions = 0
        questionObj[field].forEach(option => {
          if (option === '' && !option) missingOptions++
        })
        notFullfilled = missingOptions > 0
      }
      if (
        questionObj.type === elementTypes.LINE_ITEMS &&
        questionObj.line_item === rateOptionsObj.ENABLE_CUSTOM_OPTIONS
      ) {
        let missingOptions = 0
        questionObj[field].forEach(option => {
          if (option === '' && !option) missingOptions++
        })
        notFullfilled = missingOptions > 0
      } else {
        notFullfilled = false
      }
      break
    }
    case elementKeys.PHOTOS: {
      // checks only titles in photos
      let missingTitles = 0
      questionObj[field].forEach(photo => {
        if (!photo?.title || photo?.title === '') missingTitles++
      })
      notFullfilled = missingTitles > 0
      break
    }
    case elementKeys.ATTACHMENTS: {
      // checks only titles in attachments
      let missingTitles = 0
      questionObj[field].forEach(attachment => {
        if (!attachment?.title || attachment?.title === '') missingTitles++
      })
      notFullfilled = missingTitles > 0
      break
    }
    default:
      notFullfilled = !questionObj[field]
      break
  }
  return notFullfilled
}
